import React, {Component, Fragment} from 'react';
import autobind from 'autobind-decorator'
import classnames from 'classnames';
import {connect} from 'react-redux'

import {receiveItems, toggleChangeStatusButton, toggleMoreButton, updateItem} from '../../../actions/contents/keyword'
import {isDescendant} from "../../../utils/DomHelper"
import WindowEventHelper from "../../../lib/WindowEventHelper";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import * as StatusTypes from "../../../constants/contents/EntryStatusTypes";
import EntryStatusChangeButton from "../EntryStatusChangeButton";
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({
    changeStatusActivationId: state.keyword.moreButton.changeStatusActivationId,
    activatedId: state.keyword.moreButton.activatedId
}), dispatch => ({
    toggleChangeStatusButton: (itemId) => {
        dispatch(toggleChangeStatusButton(itemId))
    },
    toggleMoreButton: (itemId) => {
        dispatch(toggleMoreButton(itemId))
    },
    handleReceiveItems: (items, totalCount) => {
        dispatch(receiveItems(items, totalCount))
    },
    handleUpdateItem: (item) => {
        dispatch(updateItem(item))
    },
    dispatch
}))
class KeywordListItemButton extends Component {

    componentDidMount() {
        WindowEventHelper.add("click", this.handleWindowClick)
    }

    componentWillUnmount() {
        WindowEventHelper.remove("click", this.handleWindowClick)
    }

    @autobind
    handleWindowClick(e) {
        const {changeStatusActivationId, toggleChangeStatusButton, item} = this.props;
        const {root} = this.refs;
        let target = e.target;

        if ((changeStatusActivationId === item.id) && (!isDescendant(root, target))) {
            toggleChangeStatusButton(item.id);
        }
    }

    getStatusLabel(status) {

        switch (status) {
            case StatusTypes.PRIVATE :
                return "비공개";
            default :
                return "공개";
        }
    }

    @autobind
    handleChangeStatus(nextStatus) {
        const {item, handleHidden, handleVisible, toggleChangeStatusButton} = this.props;
        if (item.visibility === nextStatus) {
          toggleChangeStatusButton(item.id);
          return null;
        }

        switch (nextStatus) {
            case StatusTypes.PRIVATE :
                handleHidden(item);
                break;
            default :
                handleVisible(item);
                break;
        }

        toggleChangeStatusButton(item.id);
    }

    handleDelete() {

        const {item, handleUpdateItem, dispatch} = this.props;
        if (!item.editable) {
            alert('편집자 이상의 권한이 필요합니다.');
        } else if (confirm('선택한 키워드를 삭제하시겠습니까?')) {
            this.props.toggleMoreButton(item.id);
            item.deleting = true;
            handleUpdateItem(item);
            fetch(addPrefix("/manage/keyword/") + item.id + ".json", {
                method: "delete",
                credentials: "include",
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            })
                .then(jsonResponseHandler(dispatch))
                .then(data => {
                    this.reFetchItems();
                })
                .catch(e => {
                    item.deleting = false;
                    handleUpdateItem(item);
                    console.log(e)
                })
        }
    }

    reFetchItems() {

        const {dispatch} = this.props;

        fetch(addPrefix("/manage/keywords.json") + location.search, {
            method: 'GET',
            credentials: 'include'
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleReceiveItems(data.items, data.totalCount)
            })
            .catch(e => {
                console.log(e)
            })
    }

    render() {
        const {item, activatedId, toggleMoreButton} = this.props;
        const status = item.visibility;
        const statusLabel = this.getStatusLabel(status);
        const disabledAction = (item.deleting || !item.editable);

        return (
            <Fragment>
                <div ref="root">
                    {(item.editable === true) &&
                    <Fragment>
                        <a className='btn_post' href={addPrefix(`/manage/post/${item.id}`)}>수정</a>
                        <a className='btn_post' href='#' onClick={(e) => this.handleDelete(item)}>삭제</a>
                    </Fragment>
                    }
                    <a className='btn_post' href={addPrefix(`/manage/statistics/entry/${item.id}`)} target="_blank">통계</a>

                    <EntryStatusChangeButton
                      className='opt_post2'
                      item={item}
                      disabled={disabledAction}
                      types={[ StatusTypes.PUBLIC, StatusTypes.PRIVATE ]}
                      onChange={this.handleChangeStatus}
                    />
                </div>
            </Fragment>
        );
    }
}

export default KeywordListItemButton;
